import _asyncToGenerator from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _styled from "styled-components";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import _regeneratorRuntime from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useSpring, animated } from '@react-spring/web';
import { getAssetSrc } from '@restworld/utils-common';
import Image from 'next/image';
import { useEffect, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var MapLoader = function MapLoader(_ref) {
  var isLoading = _ref.isLoading;

  var _useState = useState(0),
      phaseIndex = _useState[0],
      setPhaseIndex = _useState[1];

  var icons = [getAssetSrc('/utils-assets/map-frame-one.svg'), getAssetSrc('/utils-assets/map-frame-three.svg'), getAssetSrc('/utils-assets/map-frame-four.svg')];
  var springProps = useSpring({
    loop: isLoading,
    from: {
      phaseIndex: phaseIndex
    },
    to: function () {
      var _to = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(next) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!isLoading) {
                  _context.next = 8;
                  break;
                }

                _context.next = 3;
                return next({
                  phaseIndex: (phaseIndex + 1) % icons.length
                });

              case 3:
                _context.next = 5;
                return new Promise(function (resolve) {
                  return setTimeout(resolve, 20);
                });

              case 5:
                // Delay between transitions
                setPhaseIndex((phaseIndex + 1) % icons.length);
                _context.next = 0;
                break;

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function to(_x) {
        return _to.apply(this, arguments);
      }

      return to;
    }(),
    config: {
      tension: 280,
      friction: 20
    }
  });
  useEffect(function () {
    if (isLoading) {
      springProps.phaseIndex.start();
    }
  }, [isLoading, springProps.phaseIndex]);

  if (!isLoading) {
    return null; // Don't render anything when isLoading is false
  }

  return /*#__PURE__*/_jsx(_StyledAnimatedDiv, {
    children: /*#__PURE__*/_jsx(_StyledImage, {
      src: icons[phaseIndex],
      alt: "Map loader",
      width: 40,
      height: 40
    })
  });
};

var _StyledAnimatedDiv = /*#__PURE__*/_styled(animated.div).withConfig({
  displayName: "map-loader___StyledAnimatedDiv",
  componentId: "sc-18a2aoz-0"
})({
  "position": "relative",
  "display": "inline-block",
  "height": "2.5rem",
  "width": "2.5rem"
});

var _StyledImage = /*#__PURE__*/_styled(Image).withConfig({
  displayName: "map-loader___StyledImage",
  componentId: "sc-18a2aoz-1"
})({
  "position": "absolute",
  "left": "0px",
  "top": "0px"
});